import React, { useState, useEffect } from 'react';
import { GridCellParams } from '@mui/x-data-grid-premium';
import CurrencyInput from '../StyledMUIComponents/CurrencyInput';
import { useSnackbar } from 'notistack';

interface InlineNewBidInputProps {
  params: GridCellParams;
  updateBids: any;
}

const InlineNewBidInput: React.FC<InlineNewBidInputProps> = ({
  params,
  updateBids,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [newBid, setNewBid] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);

  const {
    unique_id: uniqueId,
    match_type: matchType,
    is_ad_vantage_managed: isAdVantageManaged,
    advertising_network: advertisingNetwork,
  } = params.row;

  useEffect(() => {
    setDisabled(determineDisabledState(matchType));
  }, [matchType, isAdVantageManaged]);

  function determineDisabledState(matchType: string) {
    if (!isAdVantageManaged) {
      return false;
    }
    return matchType === 'BROAD' || matchType === 'PHRASE';
  }

  const getAdGroupIdFromUniqueId = (uniqueId: string) => {
    const splitUniqueId = uniqueId.split('-');
    return splitUniqueId[0];
  };

  const handleUpdateBid = async () => {
    if (newBid === '') {
      return;
    }
    const bid = parseFloat(newBid);
    if (isNaN(bid)) {
      return;
    }
    try {
      await updateBids({
        bidUpdates: [
          {
            ad_group_id: getAdGroupIdFromUniqueId(uniqueId),
            bid,
            is_ad_vantage_managed: isAdVantageManaged,
            advertising_network: advertisingNetwork,
          },
        ],
      }).unwrap();
      enqueueSnackbar('Bid updated successfully', { variant: 'success' });
    } catch (err) {
      enqueueSnackbar('Failed to update bid', { variant: 'error' });
    }
    setNewBid('');
  };
  if (disabled) {
    return null;
  }
  return (
    <CurrencyInput
      value={newBid}
      onChange={setNewBid}
      onBlur={handleUpdateBid}
      disabled={disabled}
    />
  );
};

export default InlineNewBidInput;
